import styled from 'styled-components';

const Columns = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default Columns;
